import React, { useState } from 'react';
import CarrotToggle from 'library/components/carrot-toggle';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const CarouselArrow = (props) => {
  const { onClick, direction, isEdge } = props;
  return !isEdge && <CarrotToggle
    onClick={onClick}
    active={direction === 'left'}
    direction={'right'}
    aria-label={`Go to the ${direction === 'left' ? 'previous' : 'next'} slide`}
  />;
};

CarouselArrow.propTypes = {
  onClick: PropTypes.func,
  direction: PropTypes.string,
  isEdge: PropTypes.bool,
};

const Slide = (props) => {
  const { active, next, items = [], itemsPerSlide } = props;
  const itemWidth = 100/itemsPerSlide;
  return(
    <Styled.StyledSlide
      active={active}
      next={next}
    >
      {
        items.map((item, index) =>
          <Styled.SlideItem
            itemWidth={itemWidth}
            key={index}
          >
            {item}
          </Styled.SlideItem>
        )
      }
    </Styled.StyledSlide>
  );
};

Slide.propTypes = {
  active: PropTypes.bool,
  next: PropTypes.bool,
  items: PropTypes.array,
  itemsPerSlide: PropTypes.number,
};

const Carousel = (props) => {

  const {
    items = [],
    itemsPerSlide = 1,
  } = props;

  const slides = items.reduce((memo, curr, i) => {
    if(i % itemsPerSlide === 0){
      memo.push(items.slice(i, i + itemsPerSlide));
    }
    return memo;
  }, []);

  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <Styled.CarouselContainer>
      <CarouselArrow
        direction="left"
        onClick={() => setActiveSlide(activeSlide-1)}
        isEdge={activeSlide === 0}
      />
      <Styled.CarouselContent>
        {slides.map((items, index) => (
          <Slide
            active={index === activeSlide}
            next={index === activeSlide + 1}
            itemsPerSlide={itemsPerSlide}
            items={items}
            key={index}
          />
        ))}
      </Styled.CarouselContent>
      <CarouselArrow
        direction="right"
        onClick={() => setActiveSlide(activeSlide+1)}
        isEdge={activeSlide === slides.length - 1}
      />
    </Styled.CarouselContainer>
  );
};

Carousel.propTypes = {
  items: PropTypes.object,
  itemsPerSlide: PropTypes.number,
};

export default Carousel;
